// Module
var code = "<template> <div class=\"card main-card\"> <div class=\"card-body d-flex flex-column justify-content-between\"> <slot></slot> </div> </div> </template>";
// Exports
export default code;